const handleConfirm: (title: string) => Promise<boolean> = (title) =>
  new Promise((resolve, reject) => {
    dispatchEvent(
      new CustomEvent('showConfirm', {
        detail: title,
      }),
    );
    const successCallback = () => {
      resolve(true);
      removeEventListener('acceptConfirm', successCallback);
    };
    const rejectCallback = () => {
      reject();
      removeEventListener('rejectConfirm', rejectCallback);
    };
    addEventListener('acceptConfirm', successCallback);
    addEventListener('rejectConfirm', rejectCallback);
  });

export const _confirm = async (
  title: string,
  onSuccess?: () => void,
  onReject?: () => void,
) => {
  try {
    await handleConfirm(title);
    onSuccess && onSuccess();
    return true;
  } catch (e) {
    onReject && onReject();
    return false;
  }
};

export const confirmSheet = (title: string) => {
  return new Promise((resolve) => {
    // @ts-ignore
    _confirm(
      title,
      () => resolve(true),
      () => resolve(false),
    );
  });
};
